<template>
  <tr :class="{'clickable': $can('edit', 'ServiceTasksRepository')}">
    <td>
      {{ serviceTask.title }}
    </td>
    <td>
      {{ serviceTask.service_task_type.title }}
    </td>
    <td>
      {{ serviceTask.order }}
    </td>
    <td>
      <v-chip
        small
        :color="serviceTask.wintering ? 'success' : 'error'"
        text-color="white"
        class="ma-0 caption"
      />
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'ServiceTaskRepositoryRow',
    props: {
      serviceTask: {
        type: Object,
        default: null
      }
    }
  }
</script>
